// First-run state. When the tenant's terminology is loaded the example chips
// speak the tenant's language ("NCRs by site"); otherwise generic wording is
// correct anyway. Styled to the SQ-AI tokens (sqAi.module.css).

import React from "react";
import styles from "../sqAi.module.css";
import { Sparkle } from "./icons";

const GENERIC_EXAMPLES = ["Inspections by facility", "Incidents by month", "Issues by status"];

function buildExamples(terms) {
  if (!terms) return GENERIC_EXAMPLES;
  const facility = (terms.facility || "facility").toLowerCase();
  return [
    `${terms.inspections || "Inspections"} by ${facility}`,
    `${terms.incidents || "Incidents"} by month`,
    `${terms.issues || "Issues"} by status`,
  ];
}

export default function EmptyState({ onSelectExample, disabled, terms = null }) {
  const examples = buildExamples(terms);
  return (
    <div className={styles.empty}>
      <div className={styles.emptyMark}>
        <Sparkle />
      </div>
      <h2 className={styles.emptyTitle}>Ask about your safety data</h2>
      <p className={styles.emptySub}>
        Get a chart or table back, with the assumptions made along the way. Follow-ups keep the context.
      </p>
      <div className={styles.exampleRow}>
        {examples.map((ex) => (
          <button key={ex} type="button" className={styles.example} onClick={() => onSelectExample(ex)} disabled={disabled}>
            {ex}
          </button>
        ))}
      </div>
    </div>
  );
}
